import ReactGA from "react-ga4";
import { getDevicePlatform } from "./helpers";

const ENVIRONMENT = process.env.REACT_APP_ENV || "development";

export const TRACKING_ID = ENVIRONMENT === "prod" ? "G-JCM7Z4RL5L" : null;

export const logPageView = (page, title) => {
  try {
    if (ENVIRONMENT === "prod") {
      ReactGA.send({ hitType: "pageview", page, title });
    }
  }
  catch (error) {
    console.error("Error logging page view:", error);
  }
};

export const logRecommendedPromptsActions = (category, action, userId, customFields = {}) => {
  try {
    const deviceType = getDevicePlatform();
    if (ENVIRONMENT === "prod") {
      ReactGA.event(action, { category, user_id: userId, device_type: deviceType, ...customFields });
    }
  }
  catch (error) {
    console.error("Error logging recommended prompts actions", error);
  }
};
